module.exports = __webpack_public_path__ + "static/img/zj02.feba9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zj02.png
// module id = 139
// module chunks = 0